import styled from 'styled-components';
import { colors } from '../../../utils/colors';
import { Button } from '@mui/material';

export const ButtonTerBox = styled(Button)`
  padding: 3px 40px !important;
  margin: 5px !important;
  border-radius: 5px !important;
  color: ${colors.branco} !important;
  font-size: 12px !important;
  background: grey !important;
  border: 1px solid grey !important;
`;
